export const defaultPartnerAlias = 'kampanje';

export const defaultDwellingUnit = 'bolig';

/** The 6 channels included when the user picks the "6 ekstra TV-kanaler" option, sent to checkout as-is. */
export const DEFAULT_TV_CHANNEL_IDS = [47, 18, 64, 176, 41, 218];
